import { useState } from "react";

const useModalState = () => {
  const [isArchivesModalOpen, setIsArchivesModalOpen] = useState(false);
  const [isSelfAssessmentDialogOpen, setIsSelfAssessmentDialogOpen] = useState(false);
  const [isCapabilityProfileDialogOpen, setIsCapabilityProfileDialogOpen] = useState(false);
  const [isRecruitEncouragementPanelOpen, setIsRecruitEncouragementPanelOpen] = useState(false);
  const [isTokenUsageLogsOpen, setIsTokenUsageLogsOpen] = useState(false);
  const [showGameCenter, setShowGameCenter] = useState(false);

  return {
    isArchivesModalOpen,
    setIsArchivesModalOpen,
    isSelfAssessmentDialogOpen,
    setIsSelfAssessmentDialogOpen,
    isCapabilityProfileDialogOpen,
    setIsCapabilityProfileDialogOpen,
    isRecruitEncouragementPanelOpen,
    setIsRecruitEncouragementPanelOpen,
    isTokenUsageLogsOpen,
    setIsTokenUsageLogsOpen,
    showGameCenter,
    setShowGameCenter,
  };
};

export default useModalState;
